module.exports = __webpack_public_path__ + "media/success_sweepstakes/submit-71b5f5e5.svg";